<template>
  <div class="sign-up">
    <p>Let's create a new account !</p>
    <input type="text" v-model="firstname" placeholder="First Name"><br>
    <input type="text" v-model="lastname" placeholder="Last Name"><br>
    <input type="text" v-model="email" placeholder="Email"><br>
    <input type="password" v-model="password" placeholder="Password"><br>
    <button v-on:click="signUp">Sign Up</button>
    <span>or go back to
      <router-link to="/login">login</router-link>.</span>
  </div>
</template>

<script>
import firebase from 'firebase';
import { db } from '../firebase';

export default {
  name: 'signUp',
  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
    };
  },
  methods: {
    signUp() {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          // Create document in users -- tie the auth uid to document id
          db.doc(`users/${user.uid}`).set({
            first: this.firstname,
            last: this.lastname,
            email: this.email,
            createdAt: new Date(),
          })
          .then(() => {
            // Move app to main page
            this.$router.replace('/plates');
          })
          .catch((err) => {
            alert(`Oops. ${err.message}`);
          });
        }, (err) => {
        alert(`Oops. ${err.message}`);
      });
    },
  },
};
</script>

<style scoped>
.signUp {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}

button {
  margin-top: 10px;
  width: 10%;
  cursor: pointer;
}

span {
  display: block;
  margin-top: 20px;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue